import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { message } from 'antd';
import { getUserPermissions } from 'store/permissions/selectors';
import { useCurrentUser } from 'store/users/selectors';

export const usePermissionUpdateNotification = () => {
    const currentUser = useCurrentUser();
    const userPermissions = useSelector(getUserPermissions);
    const prevPermissionsRef = useRef(null);
    const isFirstRenderRef = useRef(true);

    useEffect(() => {
        if (!currentUser || !currentUser.id) {
            return;
        }

        const currentPermissions = userPermissions[currentUser.id];
        
        if (isFirstRenderRef.current) {
            prevPermissionsRef.current = currentPermissions;
            isFirstRenderRef.current = false;
            return;
        }

        if (prevPermissionsRef.current && currentPermissions) {
            const prevPerms = prevPermissionsRef.current.permissions || {};
            const currPerms = currentPermissions.permissions || {};
            
            const prevKeys = Object.keys(prevPerms);
            const currKeys = Object.keys(currPerms);
            
            const hasChanged = 
                prevKeys.length !== currKeys.length ||
                prevKeys.some(key => prevPerms[key] !== currPerms[key]);

            if (hasChanged) {
                message.info({
                    content: 'Your permissions have been updated. Some features may now be available or restricted.',
                    duration: 5,
                    key: 'permissions-update',
                });
            }
        }

        prevPermissionsRef.current = currentPermissions;
    }, [userPermissions, currentUser]);
};

